import { InjectionToken } from '@angular/core';
import { Language } from '@qtek/shared/models';
import { distinctUntilChanged, filter, mergeMap, Observable, take } from 'rxjs';

export const DebugTranslationsDI = new InjectionToken<boolean>(
  'debugTranslationsDI'
);
export const LanguagesArray: Language[] = ['pl_PL', 'en_US', 'es_US'];
export const TRANSLATION_CORE_KEY = 'TranslationCoreKey';

export interface TranslationCoreState {
  lang: Language;
  version: string;
  translations: Record<Language, Record<string, string>>;
  error: Error | null;
}

export const translationCoreInitialState: TranslationCoreState = {
  lang: 'en_US',
  version: null,
  translations: {
    en_US: {},
    pl_PL: {},
    es_US: {},
  },
  error: null,
};

export function passWhenTrue<T>(isTrue$: Observable<boolean>) {
  return function <T>(source: Observable<T>) {
    return source.pipe(
      mergeMap(() => isTrue$),
      distinctUntilChanged(),
      filter(isTrue => !!isTrue),
      take(1),
      mergeMap(() => source)
    );
  };
}
